import { render } from "./DetailsView.vue?vue&type=template&id=e9c423bc&scoped=true"
import script from "./DetailsView.vue?vue&type=script&lang=js"
export * from "./DetailsView.vue?vue&type=script&lang=js"

import "./DetailsView.vue?vue&type=style&index=0&id=e9c423bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c423bc"]])

export default __exports__